var EVENTS = {
	MODAL_VIDEO_CLOSE : "MODAL_VIDEO_CLOSE",
	///////////////////////////////////////////////
	//TRACKING EVENTS
	//////////////////////////////////////////////
	
	TRACKING_PAGE : "TRACKING_PAGE",
	TRACKING_CLICK : "TRACKING_CLICK",

	///////////////////////////////////////////////
	//VISIBILITY EVENTS
	//////////////////////////////////////////////
	
	VISIBILITY_CHANGE  : "VISIBILITY_CHANGE",

	RESIZE : "RESIZE",
	TOGGLERENDER : "TOGGLERENDER",
	SHOWEDITIMAGE : "SHOWEDITIMAGE", //GETS DISPATCHED EVERYTIME WE SHOW CANVAS SO WE CAN RESET ALL
	SHOW_FILTERS : "SHOW_FILTERS",
	GENERATE_IMAGE : "GENERATE_IMAGE",

	///////////////////////////////////////////////
	//SLIDER EVENTS
	//////////////////////////////////////////////

	SCALE_RANGE_CHANGE : "SCALE_RANGE_CHANGE", //GETS DISPATCHED WHEN IMAGE MAX AND MIN SCALE RANGE GETS CALCULATED
	RESIZE_SLIDER_UPDATE : "RESIZE_SLIDER_UPDATE",//GETS DISPATCHED WHEN SLIDER IS MOVED
	CONTRAST_SLIDER_UPDATE : "CONTRAST_SLIDER_UPDATE",//GETS DISPATCHED  WHEN SLIDER IS MOVED
	BRIGHTNESS_SLIDER_UPDATE : "BRIGHTNESS_SLIDER_UPDATE",

	///////////////////////////////////////////////
	//WEBCAM EVENTS
	//////////////////////////////////////////////

	WEBCAMBTN : "WEBCAMBTN",
	CHANGE_WEBCAM_BTN : "CHANGE_WEBCAM_BTN",
	STOP_WEBCAM : "STOP_WEBCAM",
	WEBCAM_CHANGE : "WEBCAM_CHANGE"

	///////////////////////////////////////////////
	//PAGE EVENTS
	//////////////////////////////////////////////

	///////////////////////////////////////////////
	//WEBCAM EVENTS
	//////////////////////////////////////////////


};
